import React from 'react';

const Pagination = ({ page = 0, pageCount = 0, onPrev = () => {}, onNext = () => {} }) => {
    return (
        <div className="sales-pagination mb-5">
            <button className="btn btn-sm" type="button" onClick={onPrev} disabled={page === 1}>
                Prev
            </button>
            <span>
                Page {page} of {pageCount}
            </span>
            <button className="btn btn-sm" type="button" onClick={onNext} disabled={page >= pageCount}>
                Next
            </button>
        </div>
    );
};

export default Pagination;
